import { jsx as _jsx } from "react/jsx-runtime";
import { FaCheck } from 'react-icons/fa';
import { ToolBarButton } from './ToolBarButton';
export function SaveButton(props) {
    return (_jsx(ToolBarButton, { id: "save-button", ...props, intent: "success", icon: _jsx(FaCheck, {}) }));
}
